import type React from 'react'
import { useState, useEffect } from 'react'

interface HoverImageProps {
  normalSrc: string
  hoverSrc: string
  alt: string
  active: boolean
  className?: string
  activeClassName?: string
  content?: React.ReactNode
  transitionDuration?: number
  lazyLoad?: boolean
  aspectRatio?: string // 例如 "16/9"
}

const HoverImage: React.FC<HoverImageProps> = ({
  normalSrc,
  hoverSrc,
  alt,
  className = '',
  activeClassName = '',
  transitionDuration = 300,
  lazyLoad = true,
  active = false,
  aspectRatio = null,
  content = '',
}) => {
  const [isLoaded, setIsLoaded] = useState(false)
  const [hoverImageLoaded, setHoverImageLoaded] = useState(false)
  // 预加载悬停图片
  useEffect(() => {
    if (lazyLoad) {
      const img = new Image()
      img.src = hoverSrc
      img.onload = () => {
        setHoverImageLoaded(true)
      }
    }
  }, [hoverSrc, lazyLoad])

  return (
    <div
      className={`relative bg-[#000000] cursor-pointer grid grid-cols-1 grid-rows-1 overflow-hidden ${className} ${active ? activeClassName : ''}`}
      style={aspectRatio ? { aspectRatio } : {}}
    >
      {content}
      {/* 正常状态图片 */}
      <div
        className={`bg-transparent col-start-1 row-start-1 transition-opacity duration-${transitionDuration} ${
          active ? 'opacity-0' : 'opacity-100'
        } ${isLoaded ? '' : 'opacity-0'}`}
        style={{ transitionDuration: `${transitionDuration}ms` }}
      >
        <img
          src={normalSrc}
          alt={alt}
          className="w-full h-full object-cover"
          onLoad={() => {
            setIsLoaded(true)
          }}
          loading={lazyLoad ? 'lazy' : 'eager'}
        />
      </div>

      {/* 悬停状态图片 */}
      <div
        className={`bg-transparent col-start-1 row-start-1 transition-opacity duration-${transitionDuration} ${
          active ? 'opacity-100' : 'opacity-0'
        } ${hoverImageLoaded ? '' : 'opacity-0'}`}
        style={{ transitionDuration: `${transitionDuration}ms` }}
      >
        <img
          src={hoverSrc}
          alt={alt}
          className={'w-full h-full object-cover'}
          loading={lazyLoad ? 'lazy' : 'eager'}
        />
      </div>

      {/* 加载状态骨架 */}
      {!isLoaded && (
        <div
          className={`bg-transparent col-start-1 row-start-1 bg-gray-200 animate-pulse w-full h-full ${className}`}
        ></div>
      )}
    </div>
  )
}

export default HoverImage
